import { getClinicianDocumentTypes } from "api/clinicians";
import { useQuery } from "react-query";

export const useGetClinicianDocumentTypes = () => {
  return useQuery(["clinicianDocumentTypes"], () => getClinicianDocumentTypes(), {
    keepPreviousData: true, // this is used to avoid flickering
  });
};
